module.exports = __webpack_public_path__ + "img/door.2488ce76.svg";